import { useTheme } from 'styled-components';

import { AdminRole } from 'constants/enums';

import { Container } from './styles';

interface Props {
  children: keyof typeof AdminRole;
}

export const RoleContainer = ({ children }: Props) => {
  const theme = useTheme();

  const backgroundColor = Object.freeze({
    [AdminRole.Superadmin]: theme.colors.white.main,
    [AdminRole.Admin]: 'rgba(229, 229, 229, 0.4)',
  });

  const color = Object.freeze({
    [AdminRole.Superadmin]: theme.colors.black.main,
    [AdminRole.Admin]: theme.colors.white.main,
  });

  return (
    <Container style={{ backgroundColor: backgroundColor[children] }}>
      <h5 style={{ color: color[children] }}>{children}</h5>
    </Container>
  );
};
